import { render, staticRenderFns } from "./IndexBack.vue?vue&type=template&id=629fd867&scoped=true&"
import script from "./IndexBack.vue?vue&type=script&lang=js&"
export * from "./IndexBack.vue?vue&type=script&lang=js&"
import style0 from "./IndexBack.vue?vue&type=style&index=0&id=629fd867&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629fd867",
  null
  
)

export default component.exports